import { appData } from "@/helpers/global";

const timerKey = "_timer";
class WaitTimer {    
    constructor(name, timeOut) {
        this.name = name;
        this.timeOut = timeOut * 1000;
        this.lastFetchTime = this.getLastFetchTime();
    }
    resetLastFetchTime() {
        this.lastFetchTime = Date.now();
        let timerData = appData.store.get(timerKey, {});
        timerData[this.name] = this.lastFetchTime.toString();
        appData.store.set(timerKey, timerData);
    }
    setLastFetchTime(time) {
        this.lastFetchTime = time;
        let timerData = appData.store.get(timerKey, {});
        timerData[this.name] = this.lastFetchTime.toString();
        appData.store.set(timerKey, timerData);
    }
    getLastFetchTime() {
        const storedTime = appData.store.get(timerKey, {})[this.name];
        return storedTime ? parseInt(storedTime) : null;
    }
    isTimeExpired(expiryTime) {
        if (!this.lastFetchTime) {
            return true;
        }
        const currentTime = Date.now();
        return (currentTime - this.lastFetchTime) > expiryTime;
    }
}
export default WaitTimer;